var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88438 4.58711C6.11875 4.45273 6.40938 4.43086 6.64062 4.59961L11.1406 7.34961C11.3625 7.48711 11.5 7.72773 11.5 7.99023C11.5 8.25273 11.3625 8.49336 11.1406 8.63086L6.64062 11.3809C6.40938 11.5215 6.11875 11.5277 5.88438 11.3934C5.64687 11.2621 5.5 11.0121 5.5 10.7402V5.21211C5.5 4.96836 5.64687 4.71836 5.88438 4.58711ZM16 7.99023C16 12.409 12.4187 15.9902 8 15.9902C3.58125 15.9902 0 12.409 0 7.99023C0 3.57148 3.58125 -0.00976562 8 -0.00976562C12.4187 -0.00976562 16 3.57148 16 7.99023ZM8 1.49023C4.40938 1.49023 1.5 4.39961 1.5 7.99023C1.5 11.5809 4.40938 14.4902 8 14.4902C11.5906 14.4902 14.5 11.5809 14.5 7.99023C14.5 4.39961 11.5906 1.49023 8 1.49023Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.fa9a61705b6f32674ed6538d08176dab.svg";
export { ForwardRef as ReactComponent };